var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "multi-asset-cell", on: { click: _vm.openDetail } },
    [
      _vm.assets && _vm.assets.length > 0
        ? _c("div", { staticClass: "cell-preview" }, [
            _c(
              "div",
              { staticClass: "first-asset" },
              [
                _vm.isImageType && _vm.getAssetUrl(_vm.assets[0])
                  ? _c("img", {
                      staticClass: "preview-thumb",
                      attrs: { src: _vm.getAssetUrl(_vm.assets[0]) },
                    })
                  : _c(
                      "md-icon",
                      { style: { color: _vm.getFileColor(_vm.assets[0]) } },
                      [_vm._v(_vm._s(_vm.cellIcon))]
                    ),
                _vm._v(" "),
                !_vm.isImageType
                  ? _c("span", { staticClass: "first-name" }, [
                      _vm._v(_vm._s(_vm.assets[0].name)),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _vm.assets.length > 1
              ? _c("span", { staticClass: "asset-badge" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("table.multiAssetMoreCount", {
                        count: _vm.assets.length - 1,
                      })
                    )
                  ),
                ])
              : _vm._e(),
          ])
        : _c(
            "PermissionController",
            { attrs: { permissions: ["table.update"] } },
            [
              _c(
                "div",
                {
                  staticClass: "upload-placeholder",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.openDetail.apply(null, arguments)
                    },
                  },
                },
                [_c("md-icon", [_vm._v(_vm._s(_vm.uploadIcon))])],
                1
              ),
            ]
          ),
      _vm._v(" "),
      _vm.detailVisible
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.field.name,
                okText: _vm.$t("message.save"),
                loading: _vm.saving,
                className: "multi-asset-detail-modal keydown-prevent-modal",
              },
              on: { cancel: _vm.closeDetail, ok: _vm.saveChanges },
            },
            [
              _c(
                "div",
                {
                  staticClass: "detail-content",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                    },
                  },
                },
                [
                  _vm.hasGalleryPreview
                    ? _c(
                        "div",
                        {
                          staticClass: "ma-modal-mode-tabs",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                            },
                          },
                        },
                        [
                          _c(
                            "a-radio-group",
                            {
                              attrs: { "button-style": "solid" },
                              model: {
                                value: _vm.mediaModalMode,
                                callback: function ($$v) {
                                  _vm.mediaModalMode = $$v
                                },
                                expression: "mediaModalMode",
                              },
                            },
                            [
                              _c(
                                "a-radio-button",
                                { attrs: { value: "preview" } },
                                [_vm._v(_vm._s(_vm.$t("table.galleryPreview")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "a-radio-button",
                                { attrs: { value: "edit" } },
                                [_vm._v(_vm._s(_vm.$t("table.editMedia")))]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasGalleryPreview && _vm.mediaModalMode === "preview"
                    ? _c("div", { staticClass: "ma-preview-pane" }, [
                        _vm.localAssets.length > 0
                          ? _c(
                              "div",
                              { staticClass: "ma-files-grid" },
                              _vm._l(_vm.localAssets, function (asset, idx) {
                                return _c(
                                  "div",
                                  {
                                    key: asset._id || idx,
                                    staticClass: "ma-file-card",
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.openMediaGallery(idx)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "ma-file-icon" },
                                      [
                                        _vm.isMultiImageField &&
                                        _vm.getAssetUrl(asset)
                                          ? _c("img", {
                                              attrs: {
                                                src: _vm.getAssetUrl(asset),
                                              },
                                            })
                                          : _vm.isMultiVideoField
                                          ? _c("a-icon", {
                                              staticClass:
                                                "ma-preview-type-icon ma-preview-type-icon-video",
                                              attrs: { type: "play-circle" },
                                            })
                                          : _vm.isMultiAudioField
                                          ? _c("a-icon", {
                                              staticClass:
                                                "ma-preview-type-icon ma-preview-type-icon-audio",
                                              attrs: { type: "sound" },
                                            })
                                          : _c("a-icon", {
                                              staticClass:
                                                "ma-preview-type-icon ma-preview-type-icon-file",
                                              attrs: {
                                                type: _vm.previewCardAntIcon(
                                                  asset
                                                ),
                                              },
                                            }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "ma-file-name",
                                        attrs: { title: asset.name },
                                      },
                                      [_vm._v(_vm._s(asset.name))]
                                    ),
                                  ]
                                )
                              }),
                              0
                            )
                          : _c(
                              "div",
                              { staticClass: "ma-empty-preview" },
                              [
                                _c("a-icon", {
                                  attrs: { type: _vm.emptyPreviewAntIcon },
                                }),
                                _vm._v(" "),
                                _c("p", [_vm._v(_vm._s(_vm.emptyPreviewText))]),
                              ],
                              1
                            ),
                      ])
                    : [
                        _c(
                          "div",
                          { staticClass: "detail-assets-grid" },
                          _vm._l(_vm.localAssets, function (asset, index) {
                            return _c(
                              "div",
                              {
                                key: asset._id || index,
                                staticClass: "detail-asset-chip",
                              },
                              [
                                _vm.isImageType && _vm.getAssetUrl(asset)
                                  ? _c("img", {
                                      staticClass: "chip-thumb",
                                      attrs: { src: _vm.getAssetUrl(asset) },
                                    })
                                  : _vm.isVideoType
                                  ? _c(
                                      "md-icon",
                                      {
                                        staticClass: "chip-icon",
                                        staticStyle: { color: "#1890ff" },
                                        nativeOn: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.showVideoModal(asset)
                                          },
                                        },
                                      },
                                      [_vm._v("play_circle_outline")]
                                    )
                                  : _vm.isAudioType
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "chip-audio",
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.toggleAudio(asset._id)
                                          },
                                        },
                                      },
                                      [
                                        _c("md-icon", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.audioStates[asset._id]
                                                ? "pause_circle"
                                                : "play_circle"
                                            )
                                          ),
                                        ]),
                                      ],
                                      1
                                    )
                                  : _c(
                                      "md-icon",
                                      {
                                        staticClass: "chip-icon",
                                        style: {
                                          color: _vm.getFileColor(asset),
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.getFileIcon(asset)))]
                                    ),
                                _vm._v(" "),
                                !_vm.isImageType &&
                                !_vm.isVideoType &&
                                !_vm.isAudioType
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "chip-name chip-link",
                                        attrs: {
                                          href: _vm.getAssetUrl(asset),
                                          target: "_blank",
                                          download: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(asset.name))]
                                    )
                                  : _c("span", { staticClass: "chip-name" }, [
                                      _vm._v(_vm._s(asset.name)),
                                    ]),
                                _vm._v(" "),
                                _vm.isAudioType
                                  ? _c("audio", {
                                      ref: "audio_" + asset._id,
                                      refInFor: true,
                                      attrs: { src: _vm.getAssetUrl(asset) },
                                      on: {
                                        ended: function ($event) {
                                          _vm.audioStates[asset._id] = false
                                        },
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.readonly
                                  ? _c(
                                      "PermissionController",
                                      {
                                        attrs: {
                                          permissions: ["table.update"],
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "chip-remove",
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.removeLocalAsset(
                                                  index
                                                )
                                              },
                                            },
                                          },
                                          [_c("md-icon", [_vm._v("close")])],
                                          1
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        !_vm.readonly
                          ? _c(
                              "PermissionController",
                              { attrs: { permissions: ["table.update"] } },
                              [
                                _c(
                                  "a-upload",
                                  {
                                    staticClass: "detail-upload",
                                    attrs: {
                                      "before-upload": _vm.beforeUpload,
                                      "custom-request": _vm.uploadFileLocal,
                                      "show-upload-list": false,
                                      accept: _vm.acceptedFileTypes,
                                      multiple: true,
                                    },
                                  },
                                  [
                                    _c(
                                      "a-button",
                                      {
                                        attrs: {
                                          icon: "plus",
                                          loading: _vm.uploading,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(_vm.$t("table.addMore")) +
                                            "\n                    "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                ],
                2
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.galleryVisible && _vm.hasGalleryPreview && _vm.localAssets.length > 0
        ? _c("MultiAssetMediaPreviewOverlay", {
            attrs: {
              variant: _vm.galleryVariant,
              assets: _vm.localAssets,
              "initial-index": _vm.galleryIndex,
            },
            on: { close: _vm.closeMediaGallery },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showVideoPlayerModal && _vm.activeVideoAsset
        ? _c(
            "Modal2",
            {
              attrs: {
                "show-footer": false,
                "show-title": false,
                className: "asset-viewer-modal keydown-prevent-modal",
              },
              on: { cancel: _vm.closeVideoModal },
            },
            [
              _c("video-player", {
                ref: "modalVideoPlayer",
                staticClass: "modal-video-player",
                attrs: {
                  options: _vm.playerOptions(_vm.activeVideoAsset),
                  playsinline: true,
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }